import MuiLoadingButton from '@mui/lab/LoadingButton';
import styled from '@mui/material/styles/styled';

export const Button = styled(MuiLoadingButton)(
  ({ fullWidth }) =>
    fullWidth && {
      '> span': {
        width: '100%',
      },
    },
);
